import { useQueryParams, useHistory } from '@fs/zion-router'
import React, { useMemo } from 'react'
import { SortableResponsiveTable, ResponsiveTableRow, useSortableTable, MarginBox } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { usePlaceReportsPageData } from '../../PlaceReportsProvider'
import { getLocaleName, propertySort } from '../../placeReportsHelper'
import ContentWrapper from '../../ContentWrapper'
import { type Country } from '../../types'

const columnProperties: Record<string, keyof Country> = {
  column1: 'name',
  column2: 'score',
}

export default function PlaceReportsCountriesNavPanel(): JSX.Element {
  const [t] = useTranslation()
  const { getRegion } = usePlaceReportsPageData()
  const { query } = useQueryParams()
  const { region, country } = query
  const history = useHistory()

  const sortable = useSortableTable('column1', true)
  const { sortedColumnId, ascending } = sortable

  const sortedData = useMemo(() => {
    const countries = getRegion(region)?.countries || []
    return countries?.toSorted(propertySort(columnProperties[sortedColumnId], ascending))
  }, [ascending, sortedColumnId, getRegion, region])

  return (
    <ContentWrapper>
      <MarginBox marginX="nano" marginY="sm">
        <SortableResponsiveTable
          {...sortable}
          atSizeColumns={{
            default: {
              labels: [
                t('place-reports.nav-panel.country.label', 'Country'),
                t('place-reports.nav-panel.score.label', 'Score'),
              ],
            },
          }}
          sortableColumns={['column1', 'column2']}
          stickyHeader
          totalColumnCount={2}
          separator={<br />}
        >
          {sortedData.map((item) => {
            const { id, name, score, native_lang } = item
            return (
              <ResponsiveTableRow
                selected={Number(id) === Number(country)}
                key={id}
                column1={getLocaleName(name, native_lang)}
                column2={score}
                onClick={() => {
                  history.push(`/place-reports/?region=${region}&country=${id}`)
                }}
              />
            )
          })}
        </SortableResponsiveTable>
      </MarginBox>
    </ContentWrapper>
  )
}
